import React, { useState, useEffect } from "react";
import { Form, Container, Row, Col, Button, Alert, Spinner } from 'react-bootstrap';
import axiosInstance from "../components/AxiosInstance";
import RatingSlider from "../components/StarRating";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../Config";
import CustomModal from "../components/CustomModal";

const FeedbackForm = () => {
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [user, setuser] = useState({
        first_name: null,
        last_name: null,
        email: '',
        mobile_number: '',
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
    });

    const [message, setMessage] = useState('');
    const [rating, setRating] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [validated, setValidated] = useState(false);

    const [modalConfig, setModalConfig] = useState({
        show: false,
        title: "",
        body: "",
        type: "",
    });

    const handleCloseModal = () => {
        setModalConfig({ ...modalConfig, show: false });
    };

    useEffect(() => {
        const getUserProfile = async () => {
            try {
                const res = await axiosInstance.get("auth/profile");
                if (res.data && res.data.user) {
                    setuser(res.data.user);  // Adjust based on API structure
                } else {
                    setError('Invalid user data structure.');
                }
                setLoading(false);
            } catch (err) {
                setError("Unable to fetch profile data. Please try again!");
                setLoading(false);
            }
        };
        getUserProfile();
    }, []);

    const validateForm = () => {
        const newErrors = {};
        let isFormValid = true;

        if (!message.trim() && message.length < 10) {
            newErrors.message = "Please provide your valuable feedback in some words";
            isFormValid = false;
        }

        if (rating == 0) {
            setModalConfig({
                show: true,
                title: "Error",
                body: "Please select a rating between 1 to 5 !",
                type: "error",
            });
            newErrors.rating = "Please select a rating between 1 to 5.!";
            isFormValid = false;
        }
        setErrorMessage(newErrors);
        return newErrors;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        const validationError = validateForm();
        if (Object.keys(validationError).length === 0) {
            try {
                setIsSubmitting(true);
                let req = { user_id: user.user_id, user_message: message, user_rating: rating };
                var url = API_URL + "auth/userFeedback";
                const response = await axiosInstance.post(url, req);
                setSuccessMessage(response.data.message);
            } catch (error) {
                // Handle any errors
                if (error.response) {
                    // The server responded with an error
                    console.error("Error response:", error.response.data);
                    setError("An error occurred. Please try again.");

                } else if (error.request) {
                    // The request was made but no response was received
                    console.error("Error request:", error.request);
                    setError("No response from the server. Please try again later.");
                } else {
                    // Something else caused the error
                    console.error("Error:", error.message);
                    setError("An unknown error occurred. Please try again.");
                }
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const handleCancel = () => {
        navigate("/dashboard");
    }




    if (loading) {
        return (
            <div><br /> <br />
                <br /> <br />
                <Container className="collaborate-section rounded">
                    <Row className="justify-content-center">
                        <Col xs="auto">
                            <Spinner animation="border" variant="primary" />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    if (error) {
        return (
            <div><br /> <br />
                <br /> <br />
                <Container className="shadow p-4 rounded bg-white">
                    <Row className="justify-content-center">
                        <Col>
                            <div className="alert alert-danger">{error}</div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <div>
            <Container className="collaborate-section rounded">
                {successMessage && <Alert variant="success">{successMessage}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}
                <Row>
                    <Col></Col>
                    <Col xs={8}>
                        <h3>
                            Dear {user.first_name} {user.last_name}
                        </h3>
                        <Form noValidate validated={validated} >
                            <Row>
                                <Alert variant='info'>
                                    <p>
                                        We truly appreciate any additional comments or suggestions you may have! Your feedback is invaluable in improving the app for all users.
                                    </p>
                                    <p>We'd love to hear your thoughts! Could you please provide feedback on the <b><i><u>E-RECEIPT</u></i></b> app?</p>
                                </Alert>
                            </Row>
                            <Form.Group controlId="formMessage">
                                <Form.Label>Your Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    required
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Write your feedback here"
                                    isInvalid={!!errorMessage.message}
                                />
                                <Form.Control.Feedback type="invalid">{errorMessage.message}</Form.Control.Feedback>
                            </Form.Group>
                            <br />
                            <Form.Group controlId="formRating">
                                <RatingSlider required value={rating} onChange={setRating} />
                            </Form.Group>
                            <br />
                            <Row className="mb-3">
                                <Form.Group as={Col} className="text-end" controlId="formGridCity">
                                    <Button variant="light" type="reset" onClick={handleCancel} >
                                        Cancel
                                    </Button>
                                </Form.Group>
                                <Form.Group as={Col} controlId="formGridCity">
                                    <Button variant="primary" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                                        {isSubmitting ? "Submitting..." : "Submit"}
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Col>
                    <Col></Col>
                </Row>
            </Container>
            <CustomModal
                show={modalConfig.show}
                title={modalConfig.title}
                body={modalConfig.body}
                type={modalConfig.type}
                onClose={handleCloseModal}
            />
        </div>
    );
};

export default FeedbackForm;